<template>
    <div>
        <router-view v-if="isRouterAlive"></router-view>
    </div>
</template>

<script>
    // import keepAlivePage from './js/keepAlive'
    import { Tabbar, TabbarItem } from 'vant';
    export default {
        name:'',
        components: {Tabbar, TabbarItem},
        provide(){
          return{
            reload:this.reload
          }
        },
        data() {
            return {
                active: 'purchase',
                // keepAlivePage: keepAlivePage,
                showNav: true, // 是否显示底部tabbar
                currentRouter: location.hash,
                showFootNavPage: ['#/purchase', '#/prizeShow', '#/shareOrder', '#/myParticipation',],
                isRouterAlive:true,
            }
        },
        watch:{
            // 如果路由有变化，会再次执行该方法
            '$route': 'getRouterInfo'
        },
        mounted() {
            // this.hideOptionMenu();
            this.getRouterInfo()
            // console.log(this.currentRouter)
        },
        methods:{
            // 显示微信右上角菜单项（IOS系统下，一旦关闭\打开之后，后续页面会持续关闭\打开，要手动开关！）
            hideOptionMenu() {
                if (typeof WeixinJSBridge == "undefined"){
                    document.addEventListener('WeixinJSBridgeReady', function(){WeixinJSBridge.call('hideOptionMenu');}, false);
                }else {
                    WeixinJSBridge.call('hideOptionMenu');
                }
            },
            getRouterInfo() {
                console.log(this.$route)
                console.log(location.hash)
                // debugger
                // this.title = this.$route.meta.title;
                // this.beforeRouter = window.beforeRouter;
                // this.currentRouter = window.currentRouter;
                // this.isPageShowInfo();
            },
            isPageShowInfo() {
                // 页面是否需要标题层
                // this.titleShow = (hideTitlePage.indexOf(window.currentRouter) === -1 && !isWeiXin() && !isAliPay());
                // console.log(location.hash)
                this.showNav = (this.showFootNavPage.indexOf(location.hash) > -1);
                // console.log(this.showNav)
                // this.noCommonFresh = (this.noRefresh.indexOf(window.currentRouter) > -1);
            },

            reload(){
                this.isRouterAlive = false;
                this.$nextTick(function(){
                    this.isRouterAlive = true;
                })
            }
        },
    }
</script>
<style lang="less">
.router-wraper {
    // min-height: 100vh;
    // box-sizing: border-box;
}

</style>



// WEBPACK FOOTER //
// src/App.vue